<template>
  <div class="client-avatar">
    <v-btn v-if="!src" dense text class="upload-button text-none" @click="openFileDialog">
      <v-icon
        left
        color="#B331CF"
        style="margin-left:9px"
        :class="{'material-icons-outlined':(true)}">
        file_upload
      </v-icon>
      {{ $t('certificate.upload.scan') }}
    </v-btn>
    <v-btn v-else dense text class="upload-button delete" @click="clean">
      <v-icon
        left
        x-small
        color="#B331CF"
        :class="{'material-icons-outlined':(true)}"
        style="margin-left:9px"
      >
        remove_circle_outline
      </v-icon>
      {{ fileName.toString().substring(fileName.toString().lastIndexOf('\\')+1) }}
    </v-btn>
    <div class='error--text' v-if='wrongFileTypeAlertOpen'> {{ $t('wrong.file.type.alert') }} </div>
    <input accept="image/jpeg,.pdf" :ref="certificateCode" type="file" style="display: none;" @change="fileChanged" />
  </div>
</template>

<script>
export default {
  name: 'CertificateScan',
  props: {
    certificateCode: {
      required: false,
    },
    isManual: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      src: null,
      fileReader: null,
      fileName: null,
      wrongFileTypeAlertOpen: false,
    };
  },
  mounted() {
    this.fileReader = new FileReader();
    this.fileReader.onload = this.onFileReaded;
  },
  methods: {
    fileChanged() {
      const fileType = this.$refs[this.certificateCode].files[0]?.type;
      if (fileType &&
        (fileType === 'application/pdf' || fileType === 'image/jpeg')) {
        this.fileReader.readAsDataURL(this.$refs[this.certificateCode].files[0]);
        this.wrongFileTypeAlertOpen = false;
      } else {
        this.wrongFileTypeAlertOpen = true;
      }
    },
    clean() {
      this.src = null;
      this.$refs[this.certificateCode].value = null;

      this.$emit('changed', null);
    },
    onFileReaded() {
      this.src = this.fileReader.result;
      this.$emit('changed', { file: this.fileReader.result, code: this.certificateCode, isManual: this.isManual });
    },
    openFileDialog() {
      this.$refs[this.certificateCode].click();
    },
  },
  watch: {
    src() {
      this.fileName = this.$refs[this.certificateCode].value;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.error--text {
  padding-top: rem(5);
}

.client-avatar {
  display: flex;

  .image-container {
    display: flex;
    width: 100%;
    height: 100%;
    max-width: rem(240);
    max-height: rem(240);
    align-items: flex-start;
  }

  .v-image {
    border-radius: 50%;
    width: 100%;
    height: 100%;
  }

  .no-avatar-logo {
    width: 100%;
  }

  .upload-button {
    color: #5c6670;
    font-size: rem(12);
    font-weight: 500;
    letter-spacing: rem(1.07);
    line-height: rem(16);
    text-align: center;

    &.delete {
      height: rem(16);
      color: $auth-text-muted;
      font-family: $font-family-medium;
      font-size: rem(12);
      font-weight: 500;
      letter-spacing: rem(1.07);
      line-height: rem(16);
      text-align: center;
    }
  }
}
</style>
